import { PropsWithChildren } from 'react';

function HiddenSeoData({ children }: PropsWithChildren) {
  return <div className="visually-hidden">{children}</div>;
}

export default HiddenSeoData;
